export const authorDetails = {
    "Adhaar Sharma": {pic: "https://project-static-assets.s3.amazonaws.com/LoveSpreadsheets/ProfilePics/Adhaar.jpg", social: "https://twitter.com/adhaarr"},
    "Astha Sharma": {pic: "https://project-static-assets.s3.amazonaws.com/LoveSpreadsheets/ProfilePics/Astha.jpg", social: "https://twitter.com/asthapasta"},
    "Clarissa Ng": {pic: "https://project-static-assets.s3.amazonaws.com/LoveSpreadsheets/ProfilePics/ClarissaPic.jpg", social: "https://twitter.com/itsClarissaNg"},
}
